import { RequestParams } from "@core/services/http/http.type";

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_REQUEST_PARAMS = Object.freeze<RequestParams>({
  pageNum: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
});
